module.exports = __webpack_public_path__ + "img/banner-4-black.35fdc5dd.jpeg";